
import updateOrderRequest from "../requests/updateOrderRequest";
import getCartAction from "./getCartAction";

const updateOrderAction = async (session, get, field, val) => {
    await updateOrderRequest(session, get().orderID, {[field]: val});
    return getCartAction(session, false, get);
}

export default updateOrderAction;